import { OrdersRatingItem, orderRatingCast } from '../view/screens/OrdersRatingScreen/types';
import client from 'src/services/client';

const orderRating = {
  fetchOrderRating: async (id: string): Promise<OrdersRatingItem> => {
    const data = await client.get(`/v3/crm/orders-rating/${id}`);
    return orderRatingCast(data);
  },
};

export default orderRating;
